import { resolveWithdrawExtsContext } from './withdrawExts.js'

/** 代付 payType 展示名（字典未加载时的兜底） */
export const PAY_TYPE_LABELS = {
  benefitpay: 'BenefitPay',
  bank: 'Bank',
  stcpay: 'STC Pay',
  barq: 'Barq',
  urpay: 'Urpay',
  payby: 'Payby',
  aani: 'Aani',
  emoney: 'E&money',
  dupay: 'Dupay',
  wamd: 'Wamd',
  cliq: 'CliQ',
}

const PHONE_HIDDEN_PAY_TYPES = new Set(['stcpay', 'aani'])

export function getPayTypeLabel(payType) {
  if (!payType) return ''
  const key = String(payType).toLowerCase()
  return PAY_TYPE_LABELS[key] || payType
}

/** 订单详情是否展示 Phone 行 */
export function shouldShowPayoutPhone(item) {
  const wo = item?.withdrawOrder
  if (!wo?.phone) return false
  const payType = String(item?.payType || wo.payType || '').toLowerCase()
  if (PHONE_HIDDEN_PAY_TYPES.has(payType)) return false
  // BenefitPay：手机号与 Account 相同时不重复展示 Phone
  if (payType === 'benefitpay') {
    return String(wo.phone).trim() !== String(wo.receiverAccount || '').trim()
  }
  return true
}

/** 是否展示 Bank 行（与旧版 OrderView 一致：有 bankName 即展示） */
export function shouldShowPayoutBankName(item) {
  return !!item?.withdrawOrder?.bankName
}

/** Account / IBAN 字段标签 */
export function getPayoutAccountLabel(item) {
  const { currency, payType } = resolveWithdrawExtsContext(item)
  if (currency === 'BHD' && payType === 'bank') return 'IBAN'
  return 'Account'
}

export function isWalletPayoutPayType(payType) {
  return !!payType && String(payType).toLowerCase() !== 'bank'
}

/** 是否展示 Account 行（BenefitPay 默认展示 Account） */
export function shouldShowPayoutAccountRow() {
  return true
}

/** 一键复制文案 */
export function buildPayoutCopyText(item, { getDisplayName, shouldHideAccountNo }) {
  const wo = item?.withdrawOrder || {}
  const payType = String(item?.payType || wo.payType || '').toLowerCase()
  const hideAccount = shouldHideAccountNo?.(item)
  const name = getDisplayName?.(item, true) ?? wo.receiverName ?? ''
  let text = ''

  if (payType === 'bank') {
    const { currency } = resolveWithdrawExtsContext(item)
    if (!hideAccount) {
      const accountLabel = currency === 'BHD' ? 'IBAN' : 'Account'
      text += `${accountLabel}: ${wo.receiverAccount || ''}\n`
    }
    if (wo.bankName) text += `BankName: ${wo.bankName}\n`
    text += `Amount: ${item.payAmount} ${item.currency}\n`
    text += `Name: ${name}`
    if (currency === 'BHD' && wo.phone) {
      text += `\nPhone: ${wo.phone}`
    }
  } else {
    if (!hideAccount) {
      text += `Account: ${wo.receiverAccount || ''}\n`
    }
    text += `Payment: ${getPayTypeLabel(payType)}\n`
    text += `Amount: ${item.payAmount} ${item.currency}\n`
    text += `Name: ${name}`
    if (item.withdrawOrder?.bankName && (payType === 'bank' || payType === 'aani')) {
      text += `\nBankName: ${wo.bankName}`
    }
    // BenefitPay：仅手机号与 Account 不同时复制 Phone
    if (
      payType === 'benefitpay'
      && wo.phone
      && String(wo.phone).trim() !== String(wo.receiverAccount || '').trim()
    ) {
      text += `\nPhone: ${wo.phone}`
    }
  }
  return text
}
